/** Parse API ISO datetime: wall-clock digits before offset are used for UI (timezone-agnostic). */
const ISO_WALL_PREFIX =
  /^(\d{4})-(\d{2})-(\d{2})T(\d{2}):(\d{2}):(\d{2})(?:\.\d+)?/;

export function parseIsoWallClock(iso: string): {
  dateStr: string;
  utcWallDate: Date;
} | null {
  const m = iso.match(ISO_WALL_PREFIX);
  if (!m) return null;
  const [, y, mo, d, h, mi, s] = m;
  const dateStr = `${y}-${mo}-${d}`;
  const utcWallDate = new Date(
    Date.UTC(
      Number(y),
      Number(mo) - 1,
      Number(d),
      Number(h),
      Number(mi),
      Number(s),
    ),
  );
  return { dateStr, utcWallDate };
}

export function wallDayUtcBounds(date: Date): {
  wallDayStart: Date;
  wallDayEnd: Date;
} {
  const y = date.getFullYear();
  const m = date.getMonth();
  const d = date.getDate();
  return {
    wallDayStart: new Date(Date.UTC(y, m, d, 0, 0, 0, 0)),
    wallDayEnd: new Date(Date.UTC(y, m, d, 23, 59, 59, 999)),
  };
}

export function timelineRangeUtcBounds(
  date: Date,
  startHour: number,
  endHour: number,
): { rangeStart: Date; rangeEnd: Date } {
  const y = date.getFullYear();
  const m = date.getMonth();
  const d = date.getDate();
  return {
    rangeStart: new Date(Date.UTC(y, m, d, startHour, 0, 0, 0)),
    rangeEnd: new Date(Date.UTC(y, m, d, endHour, 0, 0, 0)),
  };
}

export function formatUtcWallTimeLabel(date: Date): string {
  const h = date.getUTCHours();
  const min = date.getUTCMinutes();
  return `${String(h).padStart(2, "0")}:${String(min).padStart(2, "0")}`;
}

/** `datetime-local` value from a UTC-wall Date (timeline slots / API wall-clock). */
export function formatDateTimeLocalWall(value: Date): string {
  const pad = (num: number) => num.toString().padStart(2, "0");
  const year = value.getUTCFullYear();
  const month = pad(value.getUTCMonth() + 1);
  const day = pad(value.getUTCDate());
  const hours = pad(value.getUTCHours());
  const minutes = pad(value.getUTCMinutes());
  return `${year}-${month}-${day}T${hours}:${minutes}`;
}
